import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { ContextProvider } from './contexts/ContextProvider';

ReactDOM.render(
  <React.StrictMode>
    <ContextProvider>
      {/* Solo un BrowserRouter aquí */}
      <App />
    </ContextProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);